import { useEffect, useState } from 'react';
import MainContainerLeftControl from '../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import styles from './Projects.module.scss';
import ProjectsAsideListControl from './ProjectsAside/ProjectsAsideListControl/ProjectsAsideListControl';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import defaultImage from '../../../images/object_mask_profile.svg';
import ProjectsList from './ProjectsList/ProjectsList';

const Projects = () => {
  const options = '300px';

  const [projects, setProjects] = useState([]);
  const projectsList = useSelector((state) => state.projects.projects);

  useEffect(() => {
    if (!projectsList) return;
    projectsList.map((item) => {
      if (item.cover.length === 0) {
        item.cover.push({ image: defaultImage, cropped_image: defaultImage });
      }
    });
    setProjects(projectsList);
  }, [projectsList]);

  return (
    <section className={styles.projects}>
      <h1 className="visually-hidden">Проекты</h1>
      <MainContainerLeftControl widthAside={options} data={<ProjectsAsideListControl />}>
        {isMobile && <ProjectsAsideListControl />}
        {projects && <ProjectsList />}
      </MainContainerLeftControl>
    </section>
  );
};

export default Projects;
